import React, { useState, useEffect, useCallback } from "react";
import { Modal, ModalHeader, ModalBody, Table } from "reactstrap";
import { addUser, deleteUser, getFdfMasterData, getUser, getUserByEmail, updateUser } from "../../../Services/DataServices";
import GenericTable from "./GenericTable";
import { toast } from 'react-toastify';
import Loader from "../../../Components/Common/Loader";
import { useNavigate } from "react-router-dom";
import AddModal from "../../Forms/AddModal";
import EditableModal from "../../Forms/EditableModal";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { FaDownload, FaEdit, FaTrash, FaCopy } from "react-icons/fa";
import { companyMasterList } from "../../../../src/companyMasterList";

const FdfMasterDataCont = ({ isAddModalOpen, closeModal, setAddModalOpen, setNewUser, newUser }) => {

  const [masterdata, setMasterData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState();
  const [filteredData, setFilteredData] = useState([]);

  let limit = 25;

  const fetchData =  useCallback(async(page = 1, searchQuery) => {
    setLoading(true);
    const { status, result } = await getFdfMasterData({searchQuery, page, limit});
    status && setMasterData(result.data);
    status && setTotalPages(result?.pagination.totalPages);
    status && setTotalCount(result?.pagination.totalCount)
    status && setLoading(false);
  });
  const companyNames = Object.keys(companyMasterList)
  .slice(0, 1000) 
  .map((company) => ({
    companyName: company
  }));

  const DownloadCompanyNames =  Object.keys(companyMasterList)
  .map((company) => ({
    companyName: company
  }));


  const handleSearch = (event) => {
    event.preventDefault();
    
    if (!searchQuery.trim()) {
      setFilteredData(companyNames);
      return;
    }
  
    const filteredResults = companyNames.filter(company => 
      company.companyName.toLowerCase().includes(searchQuery.toLowerCase())
    );
  
    setFilteredData(filteredResults);
  };

  const handleEdit = (item) => {
    setSelectedItem(item);
    setIsEditModalOpen(true);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
  };

  const handleDelete = (item) => {
    setSelectedItem(item);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleUpdate = async (event) => {
    event.preventDefault();
    try {
      const response = await updateUser(selectedItem);
      setMasterData((prevData) => {
        const updatedData = prevData.map((user) => {
          if (user._id === response.result.result._id) {
            return response.result.result;
          }
          return user;
        });
        toast.success('User edited successfully!')
        return updatedData;

      });
      closeEditModal();
    } catch (error) {
      toast.error('Error updating user!')
      console.error("Error updating user:", error);
    }
  };

  const handleDeleteData = async (event) => {
    event.preventDefault();
    try {
      const response = await deleteUser(selectedItem);
      if (response.result.response === true) {
        // fetchData(currentPage);
        toast.success('User deleted successfully!')
        closeDeleteModal();
      }
      else {
        toast.error('Error deleting user!')
      }
    } catch (error) {
      toast.error('Error deleting user!')
      console.error("Error deleting user:", error);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleSubmit = async (data) => {
    try {
      const response = await addUser(data);
      
      if (response ) {
        closeModal();
        toast.success('User Added successfully!')
      }
    } catch (err) {
      toast.error("Failed to upload file.");
    } finally {
      setLoading(false);
    //   fetchData(currentPage)
      setAddModalOpen(false);
    }
  };

  const handleDownloadCSV = () => {
    if (DownloadCompanyNames.length === 0) {
      toast.error("No data available to download.");
      return;
    }

    const csvHeader = "Company Name\n";
    const csvRows = DownloadCompanyNames.map(row => row.companyName).join("\n");
    const csvContent = csvHeader + csvRows;

    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = "company_names.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    toast.success("CSV file downloaded successfully!");
  };

  const handleCopy = (value) => {
    navigator.clipboard.writeText(value);
    toast.success("Text copied to clip board")
  }

  const columnList = [
    {
      label: "Unique Product Name",
      cell: (row) => row.UNIQUE_PRODUCT_NAME,
    },
    {
      label: "Product",
      cell: (row) => row.PRODUCT,
    },
    // {
    //   label: "Brand Name",
    //   cell: (row) => row.BRAND_NAME.length > 0 ? row.BRAND_NAME : "-",
    // },
    {
      label: "APIs",
      cell: (row) => (<>
      <div>
        {row.UPN_ARRAY.map((elm,idx)=>(
          <div 
            key={idx}
            style={{
              width: "auto",
              display: "inline-block",
              padding: "8px 12px",
              margin: "5px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              background: "#f9f9f9",
              color: "blue",
              fontSize: "10px"
            }}
            >{elm}</div>
        ))}
      </div>
      </>),
    },
    {
      label: "ATC CATEGORY",
      cell: (row) => row.ATC_CATEGORY,
    },
    {
      label: "Cas Number",
      cell: (row) => (<>
      <button
        type="button"
        style={{
          padding: 5,
          backgroundColor: "white",
          color: "#4b38b3",
          cursor: "pointer",
        }}
        title={"Copy"}
        onClick={(e) => handleCopy(row.CASNUMBER)}
      >
        {row.CASNUMBER} &nbsp;
        <FaCopy style={{ fontSize: 16 }}/>
      </button>
      </>),
    },
  ];

  const newHandleSearch = async(query) => {
    setSearchQuery(query);
    if (query.length > 3) {
      await fetchData(currentPage, query); 
    }
    if (query.length == 0) {
      await fetchData(currentPage); 
    }
    //setFilteredData(companyNames.filter(company => company.companyName.toLowerCase().includes(searchQuery.toLowerCase())))
    //setTotalCount(companyNames.length);
  }

  useEffect(() => {
    if (searchQuery === "") {
      setFilteredData(companyNames); 
      setTotalCount(DownloadCompanyNames.length); 
    }
  }, [searchQuery]);

  useEffect(() => {
    fetchData(currentPage, searchQuery);
  }, [currentPage]);


  return (
    <div>
      <div style={{ display: "flex", marginBottom: "1%" }}>
      <form onSubmit={handleSearch} style={{ width: "100%", display: "flex", alignItems: "center" }}>

  <input
    type="text"
    placeholder={`Search by Unique Product name, Cas number, Brand name`}
    value={searchQuery}
    onInput={(e) => newHandleSearch(e.target.value?.toUpperCase())}
    style={{ width: "60%", marginRight: 20, padding: "8px", borderRadius: "5px", border: "1px solid gray" }}
  />
  <h6 className="mt-2" style={{ fontSize: 20, whiteSpace: 'nowrap' }}>
                    Total: {totalCount}
                  </h6>

</form>


      <div
      onClick={handleDownloadCSV}
  type="submit"
  style={{
    display: "flex", 
    alignItems: "center", 
    gap: 8, 
    padding: 7, 
    backgroundColor: "#4b38b3", 
    color: "white", 
    borderRadius: 4,
    cursor: "pointer",
  }}
>
  <FaDownload style={{ fontSize: 16 }} />
  <span>Download</span>
</div>
    </div>

      <GenericTable
    {...{
      columnList,
      data: masterdata,
      handlePageChange,
      totalPages,
      handleEdit,
      handleDelete,
      currentPage,
      totalCount
    }}
  />
    </div>
  );
};

export default FdfMasterDataCont;
